export default "__VITE_ASSET__76f6d4ed__"